import { Model, useRepo } from 'pinia-orm';
import User from './User';
import Company from "./Company";
import * as paidSubscriptions from "../services/PaidSubscriptionService";
import { normalizeJson } from "../../shared/helpers";
import { useCommonStore } from "../../shared/state/common";

export default class PaidSubscription extends Model {

    static get entity() {
        return 'paid-subscriptions'
    }

    static fields() {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            active: this.attr(false),
            type: this.attr(null),
            expires_at: this.attr(null),
            cancel: this.attr(false),
            sent_reminder: this.attr(false),
            updated_at: this.attr(null),
            paid_at: this.attr(null),

            //relations
            company: this.belongsTo(Company, 'company_id'),
            user: this.belongsTo(User, 'user_id')
        }
    }

    static async fetch() {
        const commonStore = useCommonStore();
        return paidSubscriptions.get(commonStore.currentCompanyId).then(result => {
            return useRepo(PaidSubscription).save(normalizeJson(result));
        });
    }
}
